import {useTranslation} from '@aboutyou/i18n';
import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {mobileOnly, tabletAndUp} from '../../../../../constants/customMedia';
import {FilterCard} from '../../../../atoms/FilterCard/FilterCard';
import {HorizontalList} from '../../../HorizontalList/HorizontalList';
import {ColorItem} from '../../FilterContent/Color/ColorItem';
import {FilterColor as Color} from '../../FilterContent/Color/types';
import {FilterFlyout, Sections} from '../FilterFlyout';
import {FilterFlyoutFooter} from '../FilterFlyoutFooter';
interface Props {
  activeColorIds: Array<string>;
  colors: Array<Color>;
  label: string;
  onColorClick: (colorId: string) => void;
  isOpen: boolean;
  open: VoidFunction;
  hide: VoidFunction;
  submit: VoidFunction;
  enableFlyoutFilter: boolean;
}

const FlyoutFilter = (props: Props) => {
  const {t} = useTranslation();
  const {
    hide,
    isOpen,
    colors,
    onColorClick,
    activeColorIds,
    enableFlyoutFilter,
    submit,
  } = props;
  return (
    <StyledFilterFlyout
      data-testid="filterFlyoutSectionPrice_filterFlyout"
      onClose={hide}
      open={isOpen}
      title={t('Color')}
      primaryButtonLabel={t('Submit')}
      secondaryButtonLabel={t('Back')}
      onPrimaryButtonClick={submit}
      footer={FilterFlyoutFooter}
    >
      <FlyoutWrapper data-testid="filterFlyoutColor">
        <List>
          {colors.map(color => (
            <FlexBasisColourItem
              color={color}
              key={`filter-flyout-color-${color.id}`}
              labelPosition="bottom"
              onClick={onColorClick}
              selected={activeColorIds.includes(`${color.id}`)}
              size="large"
              showProductCount={color.productCount > 0}
              constrainAndCenterLabel={enableFlyoutFilter}
            />
          ))}
        </List>
      </FlyoutWrapper>
    </StyledFilterFlyout>
  );
};

const StandardFilter = (props: Props) => {
  const {colors, onColorClick, activeColorIds, enableFlyoutFilter} = props;
  return (
    <StandardWrapper data-testid="filterFlyoutColor">
      <HorizontalList>
        {colors.map(color => (
          <FilterFlyoutColorItem
            color={color}
            key={`filter-flyout-color-${color.id}`}
            labelPosition="bottom"
            onClick={onColorClick}
            selected={activeColorIds.includes(`${color.id}`)}
            size="large"
            showProductCount={color.productCount > 0}
            constrainAndCenterLabel={enableFlyoutFilter}
          />
        ))}
      </HorizontalList>
    </StandardWrapper>
  );
};

export const FilterFlyoutColor: FC<Props> = props => {
  const {activeColorIds, label, open, enableFlyoutFilter} = props;
  return (
    <div data-testid="filterFlyoutSectionColor">
      <FilterCard
        count={activeColorIds.length}
        title={label}
        onClick={enableFlyoutFilter ? open : undefined}
        disableHorizontalPadding={enableFlyoutFilter}
      >
        {enableFlyoutFilter ? (
          <FlyoutFilter {...props} />
        ) : (
          <StandardFilter {...props} />
        )}
      </FilterCard>
    </div>
  );
};

const FilterFlyoutColorItem = styled(ColorItem)`
  margin-right: 1rem;
  flex-basis: calc(100% / 5);
`;

const FlexBasisColourItem = styled(ColorItem)`
  ${mobileOnly(css`
    flex-basis: calc(100% / 5);
  `)}
  ${tabletAndUp(css`
    flex-basis: calc(100% / 7);
  `)}
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
`;

const StandardWrapper = styled.div`
  margin-top: 1.375rem;
`;

const FlyoutWrapper = styled.div`
  height: 100%;
`;

const StyledFilterFlyout = styled(FilterFlyout)`
  ${Sections} {
    padding: 0;
  }
`;
